module.exports = __webpack_public_path__ + "media/images/marketing-74eedcd4.svg";